<div
    #anchor
    (click)="onToggle(popupTemplate ? popupTemplate : defaultPopupTemplate)"
>
    <ng-content></ng-content>
</div>
<!-- PopUpService template -->
<ng-template #defaultPopupTemplate>
    <div
        class="q-dropdown-popup-frame"
        [ngClass]="{
            'q-dropdown-arrow': showPopupTriangle,
            'q-dropdown-arrow-top': showPopupTriangle && !popupPositionFlip,
            'q-dropdown-arrow-bottom': showPopupTriangle && popupPositionFlip
        }"
    >
        <div
            *ngFor="let item of list"
            class="q-popup-item-container"
            (click)="onClick(item)"
        >
            <div
                *ngIf="item.value === null"
                class="q-popup-item q-popup-header"
                [class.k-text-disabled]="item?.disabled"
            >
                {{ item.label }}
            </div>
            <div
                *ngIf="item.value !== null"
                [class.k-text-disabled]="item?.disabled"
            >
                <ng-container
                    *ngTemplateOutlet="
                        itemTemplate ? itemTemplate : defaultItemTemplate;
                        context: { $implicit: item }
                    "
                ></ng-container>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #defaultItemTemplate let-item>
    <div class="q-popup-item q-popup-item-link">{{ item.label }}</div>
</ng-template>
